interface StatusBadgeProps {
  status: "live" | "upcoming" | "finished";
  minute?: number;
}

export default function StatusBadge({ status, minute }: StatusBadgeProps) {
  if (status === "live") {
    return (
      <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
        <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse-live" />
        直播中 {minute ? `${minute}'` : ""}
      </span>
    );
  }
  if (status === "upcoming") {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-md bg-primary-100 text-primary-800 text-xs font-medium whitespace-nowrap">
        即将开始
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
      已结束
    </span>
  );
}